import React from "react";
import socketio from "socket.io-client";
import REMOTE_SERVER from "../configs/remoteServer";
export const socket = socketio.connect(REMOTE_SERVER);
export const SocketContext = React.createContext();